<template>
  <div class="search-box" :class="{ 'search-focused': isFocused }">
    <input
      ref="searchInput"
      type="text"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @focus="isFocused = true"
      @blur="isFocused = false"
      @keyup.enter="$emit('search', value)"
    />
    <button class="search-btn" @click="$emit('search', value)">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SearchBox',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索雪茄...'
    }
  },
  data() {
    return {
      isFocused: false
    }
  },
  methods: {
    focus() {
      this.$refs.searchInput.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  border: 1px solid #555;
  border-radius: 2px;
  overflow: hidden;
  transition: all 0.3s;
}

.search-focused {
  border-color: #d4af37;
  box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.15);
}

.search-box input {
  background: transparent;
  border: none;
  padding: 6px 10px;
  color: #fff;
  font-size: 13px;
  width: 160px;
  outline: none;

  &::placeholder {
    color: #777;
  }
}

.search-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d4af37;
  border: none;
  padding: 6px 10px;
  color: #1a1a1a;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #c4a032;
  }
}

@media (max-width: 768px) {
  .search-box input {
    width: 100px;
  }
}
</style>
